import PropTypes from 'prop-types';
import React from 'react';

import Box       from '@mui/material/Box';
import styled    from '@mui/material/styles/styled';

// Ex. <Modal><ModalBox></ModalBox></Modal>

const ModalBox = styled(Box)(({ theme }) => ({
  position:        'absolute',
  top:             '50%',
  left:            '50%',
  transform:       'translate(-50%, -50%)',
  maxWidth:        '400px',
  width:           '90%',
  backgroundColor: theme.palette.background.paper,
  padding:         '20px',
  outline:         'none',
  borderRadius:    '8px',
}));

export default ModalBox;
